export const FILE_TYPES_LIST: string[] = [
  "1.0",
  "360securitydatadat",
  "3dconstruction3bd",
  "3dconstruction3fd",
  "3dconstruction3od",
  "3dconstruction3sd",
  "3dconstructionobj",
  "3dconstructionrun",
  "3demon3demon",
  "4db",
  "4dbase",
  "4dindx",
  "4dr",
  "4xm",
  "64lanimagel64",
  "7zip",
  "a",
  "a2r",
  "aaedat",
  "abaddonpos",
  "abbyyamd",
  "abbyyamm",
  "abbyyamt",
  "abbyylsd",
  "abf",
  "abif",
  "abilityapx",
  "abilityxdb",
  "abletonamxd",
  "abracadataaig",
  "abuselvl",
  "abyssaei",
  "abyssahx",
  "ac3dgeometryac",
  "accareaderar",
  "accdb",
  "accelmac",
  "accelpcb",
  "accelsch",
  "accessdataad1",
  "ace",
  "aceam",
  "acenotesan2",
  "acestreamacelive",
  "acis",
  "acl",
  "acornarcfs",
  "acrnema",
  "acronistib",
  "actdocumentwpa",
  "actionamicsast",
  "actionreplayduc",
  "activemimemso",
  "activespybinder",
  "activex",
  "activinspireflipchart",
  "actofwardat",
  "actual_installer",
  "actualinstaller",
  "adawareref",
  "addictadm",
  "adeximg",
  "adinstrumentsadicht",
  "adlformfrm",
  "adliba2m",
  "adlibbam",
  "adobeafm",
  "adobease",
  "adobeatf",
  "adobebc",
  "adobebct",
  "adobecff",
  "adobeeap",
  "adobefdf",
  "adobeffx",
  "adobefilmstripflm",
  "adobefm",
  "adobejxsbin",
  "adobelst",
  "adobemif",
  "adobepdx",
  "adobepfa",
  "adobepfb",
  "adobepfm",
  "adorageado",
  "adoragescp",
  "adrenalinebin",
  "adu",
  "advanced_installer",
  "advancedbat2exe",
  "advancedinstaller",
  "advancedlayoutermus",
  "aec",
  "aegisdrawing",
  "aegisgeo",
  "aero",
  "aerorat",
  "aescryptaes",
  "aff",
  "aff4",
  "affixaff",
  "affymetrixbpmap",
  "afxexecutablebinder",
  "agatdsk",
  "agemaaff",
  "ageofconanrdbdata",
  "agonsfl",
  "agstranslationtra",
  "ahnenblattahn",
  "ahpack",
  "aibblog",
  "aiff",
  "aimpacs",
  "aimpacs4",
  "airlinegli",
  "aixbackupbff",
  "akaiaudioakp",
  "aksharamalaakm",
  "aladdin4d",
  "aladdin4df",
  "aladdinatl",
  "aladdinmtr",
  "aladdintxl",
  "alana3c",
  "alana3r",
  "alb",
  "alchemyhsi",
  "alchemyres",
  "alexprotector",
  "alibrestl",
  "alicesav",
  "aliencrypter",
  "allegrodat",
  "allenquestqrm",
  "allodsres",
  "alloy",
  "alpinequestaqm",
  "alrs264",
  "alterahiof",
  "alterapcf",
  "alterascf",
  "alterawdf",
  "altirraaltstate",
  "altiumldp",
  "alz",
  "amapia3d",
  "amapixsh",
  "amateuradi",
  "amazonkindlebin",
  "amber",
  "amcomposeramc",
  "americanconquestgp",
  "americanconquestgsc",
  "americanidolwd2",
  "amiatlascountry",
  "amiatlasindex",
  "amiatlasprefs",
  "amiatlasrivers",
  "amiatlasroute",
  "amiatlasspec",
  "amiatlastown",
  "amidockconfig",
  "amigaadf",
  "amigaguideindex",
  "amigahv",
  "amigaipf",
  "amigamoneyamm",
  "amigrfx",
  "amirameshbinary",
  "amokkexejoiner",
  "amosabk",
  "amossrc",
  "amped",
  "amrwb",
  "amusicadm",
  "amusicxms",
  "amv",
  "amxmodamxx",
  "anachronoxdat",
  "anacreonsav",
  "ancestralpaf",
  "andosbkd",
  "andpakk2",
  "android",
  "androidab",
  "androidbootloaderimg",
  "angelscrypteur",
  "ani",
  "animagicmap",
  "anskyabinder",
  "antennaadf",
  "antennaata",
  "antidote",
  "aodixadx",
  "aolaby",
  "aolart",
  "aolind",
  "aolmessengerbag",
  "aolpfc",
  "aop",
  "apabixeb",
  "apexlegendsrpak",
  "apexlegendsstarpak",
  "apiviewerapv",
  "aplib",
  "apocalypsecrypter",
  "apocalypserat",
  "apocalypticaxfs",
  "appfaceurf",
  "apple2mg",
  "applecaf",
  "appledfont",
  "appledouble",
  "applefirmware",
  "applefsevd",
  "applenewtonpkg",
  "applenib",
  "applepartitionmap",
  "applescpt",
  "applesingle",
  "applets",
  "applewinaws",
  "applixwareag",
  "apricotdsk",
  "aprosysaps",
  "ar",
  "ar7routerimg",
  "arc",
  "arcexploreraep",
  "arcgise00",
  "arcgisprj",
  "arcgissdc",
  "arcgissdi",
  "archetypeacx",
  "archicad",
  "archilesscrypter",
  "archimedesapd",
  "archiveice",
  "archiveimp",
  "archosaos",
  "arcia",
  "arcsoftaui",
  "arcsystemspac",
  "arcticrat",
  "area51cryptor",
  "area51dfs",
  "arenaabk",
  "arj",
  "armamodelp3d",
  "armovierpl",
  "armprotector",
  "arsc",
  "artcamart",
  "artcamrlf",
  "artemisapr",
  "articonsicc",
  "articonsicpr",
  "artragepaintingptg",
  "artsandlettersged",
  "arturiaarp2600",
  "arturiacs80v",
  "arturiaoberheimobsp",
  "arturiaprophetprovbank",
  "arubabro",
  "asdpack",
  "asetuparv",
  "asf",
  "ashampooashprj",
  "ashampooppenc",
  "askenvreq",
  "asksamask",
  "asmprotecter",
  "aspack",
  "aspellrws",
  "asphyreasvf",
  "asprotect",
  "asquaredsig",
  "assasin",
  "assaultwingfnt",
  "assaultwinglev",
  "assaultwingspr",
  "astoundact",
  "astoundawa",
  "asymetrixtbk",
  "at4reprotector",
  "atari3d",
  "atari800wina8s",
  "ataria78",
  "atariavr",
  "ataricar",
  "atarigfb",
  "atarihyp",
  "atarilynx",
  "atarimpp",
  "ataripic",
  "atarirgb",
  "ataririp",
  "atarisc68",
  "atarisndh",
  "ataristic",
  "atariym",
  "atcocif",
  "atfstl",
  "atgcorercf",
  "athenaath",
  "atherosprf",
  "au",
  "audibleaax",
  "audio/archive",
  "audio/html",
  "audio/none",
  "audio/unknown",
  "audiobcstm",
  "audiobfstm",
  "audiocalibrationacdb",
  "audiodxm",
  "audioidsp",
  "audiointerfacedig",
  "audiokraw",
  "audiola",
  "audiomld",
  "audiosculptureadsc",
  "auditionabm",
  "aurorabmu",
  "autexexp",
  "authorwarea3w",
  "authorwarea5p",
  "authorwarea5r",
  "authorwarea7l",
  "autocadlsp",
  "autocadstl",
  "autocadxmx",
  "autodesk3ds",
  "autodeskctb",
  "autodeskdxb",
  "autodeskdxf",
  "autodeskfas",
  "autodeskfbx",
  "autodeskflc",
  "autodeskigs",
  "autodeskshx",
  "autodeskslb",
  "autodeskwire",
  "autohotkey",
  "autoit",
  "autoita3x",
  "automgenagn",
  "autorealmaur",
  "autorealmaus",
  "autoshadernd",
  "autosketchskd",
  "avanquestpvn",
  "avastchest",
  "avastpkg",
  "avastvps",
  "avastvpu",
  "avastvpx",
  "avchdbdm",
  "avchdcpi",
  "avchdmob",
  "avchdmpl",
  "avchdtid",
  "avercryptor",
  "avgcontrolctf",
  "avgpack",
  "avgstb",
  "avgupdatebin",
  "avgvaultfil",
  "avgvaultidx",
  "avi",
  "avideditoravb",
  "avidemuxidx2",
  "avif",
  "aviraavj",
  "aviraavp",
  "aviraavr",
  "avirakey",
  "aviralog",
  "aviraqua",
  "aviravdf",
  "avogadrodrawlog",
  "avs",
  "avsfld",
  "awardepa",
  "away3dawd",
  "aweomt",
  "awm",
  "axialisssp",
  "axx",
  "ayamadeusamad",
  "ayemuays",
  "aystrc",
  "azprotect",
  "azzcardfiletmp",
  "babylon",
  "backitcfg",
  "bagpipebww",
  "baltiebpr",
  "bambam",
  "bamzookizook",
  "bandanacrypter",
  "barsandpipesgchone",
  "barsandpipesgchord",
  "barsandpipessong",
  "battlecryxcr",
  "battlefieldfbrb",
  "battlezonepak",
  "baxbexcryptomite",
  "bbeblrf",
  "bcif",
  "bcpack",
  "beathovensynthesizerbss",
  "beaver",
  "beaversweepergtk",
  "beefsoftcrypter",
  "beepfxspj",
  "beepolabbsong",
  "belltechsbpf",
  "bendaglishbds",
  "benitrackerpis",
  "beospkg",
  "beria",
  "berkeleydb",
  "bernhardpos",
  "beroexepacker",
  "berotrackerbrt",
  "bethesdaesp",
  "bethesdaess",
  "bga",
  "bgblitzpdb",
  "bibliothekhic",
  "biewxlt",
  "bifrost",
  "bigfixbfa",
  "bigjigdat",
  "bigjigjg",
  "bigmuthaar",
  "billbom",
  "binary/.net",
  "binary/archive",
  "binary/dll",
  "binary/dos",
  "binary/executable",
  "binary/html",
  "binary/none",
  "binary/relocatable",
  "binary/so",
  "binary/unknown",
  "binary/vxd",
  "binarydevicexfb",
  "binaryxml",
  "binasciibsc",
  "binkbik",
  "binvoximagebinvox",
  "biodox",
  "biohmmer",
  "biomedgdf",
  "biorad1sc",
  "biosymcar",
  "biowareerf",
  "biswss",
  "bitartscrunch",
  "bitcoindat",
  "bitcoinsignedpsbt",
  "bitcrypt",
  "bitcryptencrypted",
  "bitcrypter",
  "bitdefenderavxs",
  "bitdefendercvd",
  "bitdefenderxmd",
  "bitmapaipd",
  "bitmapbtpc",
  "bitmapg9b",
  "bitmaphru",
  "bitmappco",
  "bitmappedsignum2",
  "bitmapresource",
  "bitrockpak",
  "bitwarebfx",
  "bixarchiver",
  "bizhawkbkm",
  "bjfnt",
  "blackandwhitebwm",
  "blackandwhitepat",
  "blackandwhitesad",
  "blackandwhiteter",
  "blackandwhitewal",
  "blackberryipd",
  "blacknix",
  "blackrocknev",
  "blackrocknsx",
  "bladejoiner",
  "blend3d",
  "blindwriteb5t",
  "blitzb3d",
  "blizzardblp",
  "blizzardmpq",
  "bloodraynepod",
  "blophomebhw",
  "blowfishbfa",
  "bluebytebba",
  "bluecielobrc",
  "bluemsxmcf",
  "bluescanblsc",
  "bluezonevdk",
  "bluezonezmd",
  "bluezonezmp",
  "bluezonezvt",
  "blufftitlerbt",
  "bluraybdm",
  "bluraympls",
  "blz",
  "bmfontfnt",
  "bmp",
  "bnuportpat",
  "bochsimg",
  "bohemiartm",
  "boltblt",
  "bookimp",
  "boomboxbox",
  "boomtrackercff",
  "boosttxt",
  "bootableimg",
  "borderlandssav",
  "borlandbgi",
  "borlandhlp",
  "borlandovr",
  "borlandres",
  "borlandsf",
  "bozok",
  "bpg",
  "bplist",
  "bprotector",
  "brainboxbbx",
  "brainsuitedfc",
  "brainsuitedfs",
  "brainvisionvhdr",
  "brainvisionvmrk",
  "brainwavebwg",
  "breakintopattern",
  "bricklindbd",
  "bricklindmr",
  "briobqy",
  "brlcadg",
  "brutusbad",
  "brycebr6",
  "bscdatabsc",
  "bsdiff",
  "bswriterbsw",
  "btf",
  "btsnoop",
  "buerobpd",
  "bundlefile",
  "bup",
  "buranencrypted",
  "buranransomware",
  "byobypr",
  "byobysp",
  "byonddmb",
  "bzip2",
  "c16tap",
  "c64nib",
  "c64tap",
  "cab",
  "cabri3dcgl",
  "cabri3dmac",
  "cactusjoiner",
  "cad6mkd",
  "cadent3dm",
  "cadsplannerdrw",
  "cadstdcad",
  "caffeinecscheme",
  "cajviewerkdh",
  "cakewalkove",
  "cakewalkwrk",
  "cal3dcaf",
  "cal3dcmf",
  "cal3dcrf",
  "cal3dcsf",
  "calamuscdk",
  "calamuscdt",
  "calamuscfn",
  "calamuscft",
  "calamuscir",
  "calamuscrg",
  "calamuscri",
  "calamuscrl",
  "calamuscsl",
  "calamuscvg",
  "calamusol",
  "calculuxareacar",
  "calculuxindoorcin",
  "calculuxroadcro",
  "caligaricob",
  "callofdutyff",
  "callofdutyiwi",
  "callofdutypak",
  "callofjuarezpak",
  "cals",
  "cameraprofiledng",
  "canonvrd",
  "cap",
  "capcomqsound",
  "capellacag",
  "captiveworkssdx",
  "carmageddonars",
  "carraracar",
  "carraracbr",
  "cartesiancpc",
  "cartridgec64",
  "cascadebrp",
  "casioadt",
  "casiobin",
  "casiog1a",
  "cat",
  "catia",
  "cavestorydat",
  "cavisualaef",
  "caxaexb",
  "cazipcaz",
  "cba",
  "ccp4mtz",
  "cdda",
  "cdr",
  "celestiacmod",
  "celestiatxf",
  "centralpointhlp",
  "cerber",
  "cerberus",
  "cernroot",
  "certutil",
  "cfastcft",
  "cfastin",
  "cgbi",
  "cgm",
  "cgns",
  "chainer",
  "chalkwgm",
  "chaosultdgemchs",
  "chasersav",
  "chasyscd5",
  "chasysmat",
  "cheatenginect",
  "chemdrawcdx",
  "chemdrawctr",
  "chemicalc3d",
  "chemicalcml",
  "chemicalctab",
  "chemicalrdf",
  "chemicalvamas",
  "chemsketchrpt",
  "chemsketchtmt",
  "chessmaster",
  "chessmastercm",
  "chessmasteridx",
  "chessmasterjix",
  "chiasmusxia",
  "chinayunlongencrypted",
  "chipsounday",
  "chiptunemtc",
  "chiptunepsg",
  "chiptunetfc",
  "chm",
  "chromebdic",
  "chuzzledat",
  "cicalccic",
  "cigamesdpk",
  "cigicigi",
  "cimplicityrole",
  "cimplicitysoc",
  "cin",
  "cinemalib4d",
  "cinemascopeseq",
  "cinemorphproject",
  "circad",
  "ciscoaef",
  "ciscofirmware",
  "ciscoxebin",
  "citect001",
  "civilizationbic",
  "clamavcvd",
  "clamavdiff",
  "class",
  "clickoncecdf",
  "clickteamcca",
  "clickteammfa",
  "cloantorom",
  "clonecdccd",
  "cloudcomparebin",
  "cloudkeychain",
  "clrmameprodat",
  "clustalwaln",
  "cmnphonebookphb",
  "cmvdatacmv",
  "cncreplay",
  "cocoflowsheetfsd",
  "codebreakercbs",
  "codecrypt",
  "codesyseci",
  "codesyslb6",
  "colinmcraebfl",
  "colinmcraedic",
  "colonymap1",
  "colorfontmakercfm",
  "colorschemercs",
  "colourgeniecas",
  "comiclifecomicdoc",
  "compackcom",
  "compactcpt",
  "compactpro",
  "compaq01",
  "compaqcva",
  "completegenomicstsv",
  "completetca",
  "compound",
  "compresseddark",
  "compuconerf",
  "computereyesce3",
  "conarypackage",
  "conceptdrawcdd",
  "containerxfbin",
  "contecclb",
  "coolcryptor",
  "cooleditses",
  "coolpagecpg",
  "coredesigncore",
  "corelbmf",
  "corelcc",
  "corelclk",
  "corelcmx",
  "corelcrv",
  "corelcsw",
  "corelfin",
  "corelnpm",
  "corelshr",
  "coreltex",
  "corelusr",
  "corruptiontmv",
  "cosmicblob",
  "cpack001",
  "cpbackupcfg",
  "cpbirtual",
  "cpbound",
  "cpcandy",
  "cpcemudsk",
  "cpdalek",
  "cpdemonio",
  "cpdibs",
  "cpellie",
  "cpescritorio",
  "cpflush",
  "cpglyph",
  "cpinfluenza",
  "cpio",
  "cpjogi",
  "cpkifo",
  "cpkovter",
  "cpminiduke",
  "cpmovey",
  "cppermabatt",
  "cppittytiger",
  "cppoison",
  "cprebar",
  "cprotector",
  "cpslesh",
  "cpstackexec",
  "cpt",
  "cptibbar",
  "cptick",
  "cptinygiant",
  "cpvicspy",
  "cr1ptt0rencrypted",
  "cramfs",
  "crazytalk",
  "createaquizqz",
  "createshadelights",
  "creativelabscmf",
  "creativelabsvoc",
  "creativemusicorg",
  "creativepack",
  "creativesc4",
  "creativevoc",
  "cricketckb",
  "crimsonlev",
  "crimsonsrc",
  "crlzh",
  "crocodilecyp",
  "crouzetpm3",
  "crtf",
  "crucified",
  "crunch",
  "crushcru",
  "cruzcrypter",
  "crw",
  "crx",
  "cryaklencrypted",
  "cryoapc",
  "cryobf",
  "cryohnm",
  "crypmicencrypted",
  "cryptocrackpeprotector",
  "cryptomix",
  "cryptomixrevengeencrypted",
  "cryptonite",
  "cryptorevenge",
  "cryptoshield",
  "cryptox",
  "cryptx",
  "cryptxcrypt",
  "crysisjmsf",
  "crystallographiccif",
  "csacompresseddata",
  "cso",
  "ctbl",
  "ctfmegmeg4",
  "ctfmegres4",
  "ctfmegsamslv",
  "ctxfarchivercxf",
  "cubaencrypted",
  "cubicdat",
  "cubictinymxm",
  "cultc3d",
  "cur",
  "cursorresource",
  "custommaidmodel",
  "cwk",
  "cworthycwa",
  "cwpal",
  "cxmacro",
  "cyberboardgsn",
  "cybergate",
  "cyberstepkxr",
  "cybicocvc",
  "cybikocvc",
  "cypresscysch",
  "cytometryics",
  "daa",
  "daemoncrypt",
  "daemontoolssav",
  "dalayoutdip",
  "dalkrypt",
  "dangerouswatersagg",
  "darkcomet",
  "darkcrypttcxdc",
  "darkddoser",
  "darkrat",
  "darkreignzwp",
  "darkroomxbdr",
  "darkvision",
  "dartdesktopdsk",
  "databaseprodb",
  "datacompemd",
  "datadoctordnt",
  "dateldc",
  "daubdob",
  "davelowedl",
  "davidhanneydh",
  "davidwhittakerdw",
  "db2bindbnd",
  "db2cnv",
  "dbasedbf",
  "dbasepr2",
  "dbcrypter",
  "dbpe",
  "dbx",
  "dc2ndmp",
  "dcm",
  "dcrtrencrypted",
  "dcx",
  "dds",
  "deb",
  "deception",
  "declanxwf",
  "deepburnerdbr",
  "deeperrat",
  "deepvisiondvs",
  "def",
  "defydtm",
  "delcamdgk",
  "delcamdmt",
  "delcamstl",
  "deleddmf",
  "delitrackercustomcus",
  "delphiddp",
  "delsysemg",
  "deltacaddc",
  "deltadlt",
  "deltamapdmf",
  "deltamusic2dm2",
  "delusiondel",
  "deluxeinstr",
  "deluxepaintanm",
  "demomakerseq",
  "demomaniacscript",
  "demoshielddbd",
  "denuvo",
  "depacker",
  "derivedfw",
  "descentfnt",
  "descentham",
  "descenthi",
  "descenthmel",
  "descenthog",
  "descentmvl",
  "descentpig",
  "descentplr",
  "descentpog",
  "descentrdl",
  "descentsg0",
  "describedoc",
  "desibin",
  "deskmatefig",
  "deskmatefil",
  "desmumedfc",
  "desmumeds",
  "destan3dn",
  "dex/exe",
  "dexcrypt",
  "dexdrivegme",
  "dfmaudio",
  "dfusedfu",
  "dgcaargb",
  "dgcadgc",
  "dgindexd2v",
  "dgn",
  "diabloiid2s",
  "diamondwaredwd",
  "diffracplusraw",
  "digibooster",
  "digiboosterxpk",
  "digilineardlc",
  "digimemodhw",
  "digitalillusionspdt",
  "digitalmugiciandmu",
  "digitalsounddsm",
  "digitalspeechdss",
  "digitaltraineredf",
  "digitrakkerist",
  "digitrakkermdl",
  "digitrakkerslp",
  "digitrekkerdtm",
  "diptracedch",
  "diptracedip",
  "diptraceeli",
  "diptracelib",
  "directx",
  "directxcso",
  "dirteldat",
  "disgclgcl",
  "diskimagedim",
  "diskimageudi",
  "diskimagewoz",
  "disneyxpo",
  "disordertrackerplm",
  "dizcompresseddata",
  "djvu",
  "dlinfluenza",
  "dls",
  "dlthunder",
  "dlupatrea",
  "dlupatreb",
  "dlupatrec",
  "dlupatred",
  "dmalockerencrypted",
  "dmalockervariantencrypted",
  "dmg",
  "dnamldnl",
  "dnaremoteadmin",
  "docker",
  "doctorwhoepc",
  "document/archive",
  "document/html",
  "document/none",
  "document/unknown",
  "document/xml",
  "documentaudio/none",
  "documentyaml",
  "dogwafflelyr",
  "dogwafflemix",
  "dogwaffleopt",
  "dolbymlp",
  "dolphindtm",
  "doom3save",
  "doomwad",
  "dosnavigatorcfg",
  "dossniffersnf",
  "doswf",
  "dotnetresource",
  "dprotelsch",
  "dpx",
  "dracodrc",
  "dragoncrypter",
  "drakanrsg",
  "drat",
  "drazlacedrl",
  "drcrulesexportrul",
  "dreamcastpvr",
  "dreamshield",
  "dreamstationdss",
  "drumkitdmkit",
  "drumpatchdmpatch",
  "drumtrakerdtl",
  "drwebdwl",
  "drweblst",
  "drwebvdb",
  "dsdaudio",
  "dsmiamf",
  "dtd",
  "dunedat",
  "dunedff",
  "dunedsf",
  "dunegraphdc1",
  "dungeonds2res",
  "dungeondsres",
  "duplicatorimg",
  "duxburydxb",
  "duxburydxp",
  "dvdauthorguidva",
  "dvdifo",
  "dvf",
  "dwf",
  "dwg",
  "dxpack",
  "dynacaddfnt",
  "dynadocwdl",
  "dynamicpublisherfnt",
  "dynamicsynthesizerdns",
  "dynamixbmp",
  "dynamixdyn",
  "dynamixfnt",
  "dynamixmus",
  "dynamixscr",
  "dynamixsnd",
  "dynamixtrk",
  "dynojetdjm",
  "dynojetdrf",
  "dzipdz",
  "eagamesav",
  "eagamesbig",
  "eaglebrd",
  "eagleepf",
  "eaglepro",
  "eagleusr",
  "earacheea",
  "earachewad",
  "earthbeyondmix",
  "earthresourceers",
  "earthsiegevol",
  "easecalcformcal",
  "easegll",
  "easycadecw",
  "easycadfcd",
  "easycryptoencrypted",
  "easygradeproegp",
  "easyhdrehsx",
  "easyplotep",
  "easyprintepp",
  "easyprintfd2",
  "easyrecoverybin",
  "easyrecoverydat",
  "easyworshipewb",
  "eclipsenot",
  "edgediagrammeredg",
  "ediusewc2",
  "edlibd00",
  "edrawings",
  "edrw",
  "eedraweed",
  "eedrawlib",
  "eesbinder",
  "efsueb",
  "egg",
  "eggpainttrp",
  "egopssg",
  "egosoftxmf",
  "egridegp",
  "eicar",
  "eightyonemgt",
  "eightyonet81",
  "elasticer",
  "elcomsoftcat",
  "elecbytefnt",
  "elecbytesnd",
  "elecbytespr",
  "electricpipesep3",
  "electronicartsfsh",
  "electronicebx",
  "elf32 big/core",
  "elf32 big/exe",
  "elf32 big/executable",
  "elf32 big/none",
  "elf32 big/relocatable",
  "elf32 big/so",
  "elf32 little/core",
  "elf32 little/exe",
  "elf32 little/executable",
  "elf32 little/none",
  "elf32 little/relocatable",
  "elf32 little/so",
  "elf64 big/core",
  "elf64 big/exe",
  "elf64 big/executable",
  "elf64 big/none",
  "elf64 big/relocatable",
  "elf64 big/so",
  "elf64 little/core",
  "elf64 little/exe",
  "elf64 little/executable",
  "elf64 little/none",
  "elf64 little/relocatable",
  "elf64 little/so",
  "elfresource",
  "elipackereli",
  "elitedisplaymop",
  "elitejapanejp",
  "elitejapanjcc",
  "elitepluscommandercdr",
  "em400e4i",
  "emachineshopems",
  "email/archive",
  "email/excel4",
  "email/none",
  "email/xml",
  "embedded_pe",
  "embirdecf",
  "emblazeev2",
  "embroiderybdf",
  "embroiderydst",
  "embroideryhus",
  "embroiderypec",
  "embroiderypes",
  "embroiderypxf",
  "embroideryref",
  "embroideryvip",
  "embroideryvp3",
  "emeditoresy",
  "emergencye4mod",
  "emergencyvmo",
  "emf",
  "emu80rss",
  "emuemulatorez3",
  "emulatordcmo",
  "emulatordcmo6",
  "emulatordcmotok7",
  "emulatoruef",
  "enableofficesuite",
  "encartaeyb",
  "encartam21",
  "encaseenpack",
  "encaseewf",
  "encasehash",
  "encasel01",
  "encoreenc",
  "encryptedbibleidx",
  "endnoteenf",
  "endnoteens",
  "endnoteenz",
  "energyplusepw",
  "enigmaprotector",
  "enotebws",
  "ensoniqecw",
  "ensoniqeda",
  "ensoniqede",
  "ensoniqeds",
  "ensoniqedt",
  "entrustepf",
  "envisionevp",
  "envoyevy",
  "eot",
  "epanetnet",
  "ephemerise",
  "ephemerisse1",
  "eppack",
  "erdashfa",
  "erdaslan",
  "erdasraw",
  "erebus",
  "erlangbeam",
  "escargot",
  "eschalonecmp",
  "esetsmartsecurityndf",
  "esetsmartsecuritynqi",
  "esrispatialsbx",
  "etabsmodeledb",
  "etcshowshw",
  "eternityani",
  "eternityskn",
  "etl",
  "eudemonsdnp",
  "eurekalogelf",
  "europeanedf",
  "evernoteenb",
  "everyonepianoeop",
  "everyonepianoeopm",
  "evgaprecisionusf",
  "eviewswf1",
  "evilgeniuserb",
  "evt",
  "evtx",
  "examviewbnk",
  "examvieweot",
  "examviewtst",
  "excalibur",
  "exe32pack",
  "execrypter",
  "exefog",
  "exesax",
  "exescripteditor",
  "exestealth",
  "exoticxad",
  "expressgraphgrf",
  "expression3sks",
  "expression3xpr",
  "expressor",
  "expresswarepdf",
  "exr",
  "extamigaadf",
  "extensionsortpackeresp",
  "extrabasicmacro",
  "extracad",
  "extractorencrypted",
  "extrasimplexsm",
  "extremetrackerams",
  "extronpke",
  "eyedentitypak",
  "eyemaileye",
  "ezbindarc",
  "ezdrawjoy",
  "ezeds",
  "ezip",
  "ezmovie3g2",
  "facetfacet",
  "facethemusicftm",
  "faerysav",
  "faerytalehrs",
  "fahrenheitidm",
  "falloutfos",
  "famicomfds",
  "famicomnes",
  "familytreefbc",
  "famitrackerftm",
  "famtasiafmv",
  "fanucmem",
  "farallonrpl",
  "farandolecomposerfar",
  "farandolefsm",
  "farbfeldff",
  "farmingsimulatorgrle",
  "fashiontrackerex",
  "fastcadfcd",
  "fastcadfcw",
  "fastfindffl",
  "fastgrafprf",
  "fastpack32",
  "fasttrackerxm",
  "fatalzcrypt",
  "faustmusicsng",
  "fbibinder",
  "fcmpackerfcm",
  "fcp",
  "fdi",
  "feararch00",
  "fearzpacker",
  "ffmpegframehash",
  "fiascofco",
  "fiascofdat",
  "fiascofdb",
  "fiascofidx",
  "fiascofpr",
  "fiascofrec",
  "fidapfdneut",
  "fidocadfcd",
  "fidocadfcl",
  "fidocadfcm",
  "fifaffn",
  "figfontflc",
  "figfontflf",
  "fightermakerplayer",
  "filecrypter",
  "filecrypterpro",
  "filedb",
  "fileempo",
  "fileinvestigatorfib",
  "filemaker",
  "filempak",
  "filepacker",
  "filesyncfsy",
  "filevault",
  "filevault_v1",
  "filevault_v2",
  "filezda",
  "finalburnalphafr",
  "finalcalcsheet",
  "finaldraftfdr",
  "finaleetf",
  "finalemus",
  "finalfantasylgp",
  "fineartistsnd",
  "firealpacamdp",
  "firedacfds",
  "firmwaredfu",
  "firstchoicedevice",
  "firstchoicefol",
  "firstchoicess",
  "fishingjr2",
  "fishpe",
  "fits",
  "flac",
  "flankermis",
  "flashbackspr",
  "flashpix",
  "flashswd",
  "flashsymbol",
  "flatpackref",
  "flexidatafdd",
  "flexidumpcus",
  "flightgearbtg",
  "flirfpf",
  "floorplanplusfp",
  "floppyfdd",
  "floppyimg",
  "flowfcs",
  "flowjo",
  "flstudiodmptrn",
  "flstudiogmsynth",
  "flstudiohdprg",
  "flstudiokik",
  "flstudiotkp",
  "flukeviewfvf",
  "flux",
  "fluxrat",
  "flv",
  "fmodfsb",
  "folionfo",
  "fontcreatorfcp",
  "fontlabvfb",
  "fontspeedo",
  "foobar2000fpl",
  "forgottenworldsfw",
  "formflowfrl",
  "formikfed",
  "formtooltfm",
  "formulafrm",
  "formz",
  "foxitfzip",
  "foxpropak",
  "fractalfif",
  "fractalforgemnd",
  "framemakerfmv",
  "frameworkpos",
  "freearcarc",
  "freecadasm",
  "freehandfh",
  "freehidefolderfhf",
  "freemotionsqf",
  "fritzboxexport",
  "frodofss",
  "frontpageelm",
  "fruityloopsflp",
  "frusion",
  "fsg",
  "fstf",
  "fuchstrackerfuchs",
  "fugawifcz",
  "fugawifvc",
  "fugawifx4",
  "fugawirte",
  "fugawitrk",
  "fugawiwpt",
  "fulltiltdat",
  "funcomiss",
  "funktrackerfnk",
  "funpaintfp2",
  "furcadiads",
  "furcadiafox",
  "furcadiamap",
  "fusefmf",
  "fusion",
  "futurecomposersmod",
  "futureplayerfp",
  "futurevisioncmp",
  "futurevisionfst",
  "fuxoftfxm",
  "g64imagediskg64",
  "gabrielbrn",
  "gambitefg",
  "gambitneu",
  "gambitnfg",
  "gameboxgbx",
  "gameboygbm",
  "gameboygbr",
  "gameboygbs",
  "gameboygrb",
  "gamebryokfm",
  "gamebryonif",
  "gamecontainersbf",
  "gamecubegci",
  "gamecubegcs",
  "gamecubemth",
  "gamecubesav",
  "gamefactorygam",
  "gamemakergm6",
  "gamemapssdm",
  "garmindem",
  "garmingcd",
  "garmingmp",
  "garmingpi",
  "garminimg",
  "garminlbl",
  "garminmdr",
  "garminmps",
  "garminnet",
  "garminnod",
  "garminrgn",
  "garminsrf",
  "garminsrt",
  "garmintre",
  "garmintrf",
  "garmintrk",
  "garmintyp",
  "garminvpm",
  "garrygma",
  "gasteigerctx",
  "gburnergbi",
  "gburnergbp",
  "gbx",
  "gcompressorgca",
  "gdalvrt",
  "geepdr",
  "gemimg",
  "gempacksfc",
  "gemrb2da",
  "gemrbbam",
  "gemtekbin",
  "gemviewdit",
  "genboxgco",
  "genboxgdt",
  "genboxgro",
  "genecystgs0",
  "genepixatf",
  "genericheadergenh",
  "genetecg64",
  "genieoushts",
  "gensgmv",
  "genstatgwb",
  "geogridovl",
  "geomagicstl",
  "geometergsp",
  "geometergss",
  "gho",
  "ghostrat",
  "ghostscriptupp",
  "gif",
  "gimpgbr",
  "gimpgfig",
  "gimpggr",
  "gimpgpl",
  "gimppat",
  "girlcrypter",
  "gisrussarus",
  "gisrxrxm",
  "gix protector",
  "gixprotector",
  "gkripto",
  "gltransmissionglb",
  "gluemonglue",
  "gmotormas",
  "gmshmsh",
  "gnatali",
  "gnumo",
  "gnurec",
  "goatmutilator",
  "goattrackersng",
  "gobeproductivepve",
  "gobjecttypelib",
  "gocadgocad",
  "godot4bt",
  "godotres",
  "godottres",
  "godottscn",
  "goldensoftware7bg",
  "goldensoftwarebg",
  "goldensoftwaregrd",
  "goldensoftwaregsb",
  "golfstargsr",
  "gom3dg3d",
  "goodwaygwp",
  "googlesnappy",
  "gothicpak",
  "gpstunergmi",
  "gptentry",
  "gptheader",
  "graalonlinenw",
  "grandtheftimg",
  "granitegdf",
  "graoumfgtk",
  "graph2fontg2f",
  "graphicbooting",
  "graphicworksdvg",
  "graphicworkshopthn",
  "graphingcalcgcf",
  "graphpadpzf",
  "graphtecgbd",
  "graphtecgds",
  "gravisfbd",
  "gravisfff",
  "gravispat",
  "greenfishgfi",
  "gremlingdv",
  "grigontex",
  "groundcontrolsdf",
  "grxfontfnt",
  "grzipiigrz",
  "gscolormapclr",
  "gsdrawgrf",
  "gtacol",
  "gtaifp",
  "gtasanandreasrep",
  "gtaytd",
  "guemapgmp",
  "guitarprogp",
  "guitarrigngrr",
  "guymagerinfo",
  "gzip",
  "hackhoundstealer",
  "hadoopseq",
  "haikudeltahpkg",
  "haikuhvif",
  "haikunativeicon",
  "halflife2sav",
  "halhps",
  "halionfxb",
  "hamarsofthap",
  "hamichmc",
  "hammerheadhh",
  "hangulhwp",
  "haptekhap",
  "haptekhtr",
  "harddisk000",
  "harrypotterccd",
  "harrypotterhog",
  "harvardcht",
  "harvardgraphics",
  "harvardsh3",
  "harvardshw",
  "harvardsym",
  "harvardsyw",
  "hausdesignwds",
  "havenres",
  "hawkhdf",
  "hclabhcg",
  "hcom",
  "hdd",
  "hdfide",
  "hdmrencrypted",
  "hdr",
  "headspacehsb",
  "healthlevelhl7",
  "heavyironhip",
  "heif",
  "hellcrypter",
  "helpmagicianhlx",
  "helpscribblehsc",
  "hemerahpi",
  "herdat",
  "hermesencrypted",
  "heroquestqst",
  "hexagonhxn",
  "hexelshxl",
  "hexelsxml",
  "hexworkshophbk",
  "hexworkshopmap",
  "hfsp",
  "hfsx",
  "hiddenanddangerouscnt",
  "hidepe",
  "highspeedpascallib",
  "highspeedpascalunit",
  "highwayhfd",
  "hikvisionmp4",
  "hipcompressorhip",
  "hippelhipc",
  "hippelsog",
  "hivelytrackerhvl",
  "hl72bit",
  "hl7bai",
  "hl7bedgraph",
  "hl7gaf",
  "hl7gff",
  "hl7gpad",
  "hl7gpi",
  "hl7gtf",
  "hl7narrowpeak",
  "hl7nib",
  "hl7tdf",
  "hl7vcf4",
  "hlguardzcfg",
  "hlp",
  "hmimyspacker",
  "hmzkft",
  "hnskyast",
  "hnskycmt",
  "hnskyd32",
  "hnskyhnd",
  "holahls",
  "hollywoodhfz",
  "hollywoodhwa",
  "homeaccountsha2",
  "homeworld2big",
  "hoopshsf",
  "hotbarxip",
  "houdiniblut",
  "houdinihipnc",
  "howiedavieshd",
  "hp49grb",
  "hpackhpk",
  "hpgro",
  "hpgrob",
  "hpimageupdate",
  "hppolynomialptm",
  "hqx",
  "hsihst",
  "htaedit",
  "htcsmshbk",
  "htcsplashscreenrgb565",
  "html",
  "http",
  "hudsonhes",
  "humanmachinehmp",
  "husqvarnaphv",
  "hvif",
  "hxccfg",
  "hxcfpf",
  "hxcquickdiskqd",
  "hxcupd",
  "hydrocadhcp",
  "hyperchemhin",
  "hyperion",
  "hyperpublishaeh",
  "hypersurfacesurf",
  "hyperterminalht",
  "hysyshsc",
  "iage",
  "ibmegatherereg2",
  "ibmlwp",
  "ibmpsl",
  "ibmsoftcopybki",
  "ibmsoftcopybks",
  "ibmsoftcopyboo",
  "ibmstoryboardcap",
  "ibmworkslch",
  "ibmwritingdoc",
  "icc",
  "icdraw",
  "icereaderibk",
  "icns",
  "ico",
  "iconresource",
  "icrypt",
  "icytoweritr",
  "idaidb",
  "idaids",
  "idappprotector",
  "idasig",
  "idatil",
  "idexepassword",
  "idmascfg",
  "ieeesdf",
  "iesnaies",
  "iexpress",
  "iff",
  "ifs",
  "igodem",
  "igofbl",
  "igorproigtx",
  "ildaild",
  "iliumwlt",
  "illusioniel",
  "illusionil3",
  "illusionipf",
  "ilookasb",
  "image/archive",
  "image/bmp",
  "image/dcm",
  "image/dll",
  "image/exe",
  "image/gif",
  "image/jng",
  "image/jpeg",
  "image/mng",
  "image/none",
  "image/pbm",
  "image/pct",
  "image/pgm",
  "image/png",
  "image/ppm",
  "image/psd",
  "image/ras",
  "image/tiff",
  "image/unknown",
  "image/xcf",
  "image360desktop360",
  "imagediskimd",
  "imagefinderindex",
  "imageflif",
  "imagekniferaw",
  "imagemagickmpc",
  "imagesoftimg",
  "imagoimf",
  "img",
  "img2",
  "img3",
  "imgdiffpatch",
  "implayiss",
  "impulsetrackerit",
  "imsecurerat",
  "imsmusiclst",
  "imy",
  "in2d",
  "inbinder",
  "incredimailim3",
  "indd",
  "indetectablesrat",
  "index3by5map",
  "indypainttru",
  "infinityacm",
  "infinityare",
  "infinitybif",
  "infinitychr",
  "infinitychu",
  "infinitycre",
  "infinitycrypter",
  "infinitydlg",
  "infinityeff",
  "infinitygam",
  "infinityiap",
  "infinityitm",
  "infinitykey",
  "infinitymos",
  "infinityplt",
  "infinitypro",
  "infinitysav",
  "infinityspl",
  "infinitysto",
  "infinitytbg",
  "infinitytis",
  "infinitytlk",
  "infinityvef",
  "infinityvvc",
  "infinitywavc",
  "infinitywed",
  "infinitywmp",
  "infofileflr",
  "informationiw2",
  "informativecsf",
  "innodat",
  "innosetup",
  "innosetupmsg",
  "inpageinp",
  "inputgmv",
  "inshapeiim",
  "install_anywhere",
  "installanywhere",
  "installervice",
  "installervisevct",
  "installforge",
  "installjammer",
  "installmate",
  "installshield",
  "installshieldcab",
  "installshieldinx",
  "installshieldisu",
  "instereois",
  "instereois20",
  "interfazeapp",
  "interfile",
  "interlacedbinder",
  "interlexilx",
  "internetshortcut",
  "interplaymve",
  "intertalkphone",
  "inthegroovepck",
  "ios",
  "iosmbdb",
  "iosmbdx",
  "iplbitmap",
  "iqy",
  "irissc",
  "ishneann",
  "ishneecg",
  "isisdsn",
  "isislyt",
  "iso",
  "isobusteribp",
  "isogenpcf",
  "isoisz",
  "istealer",
  "itsfileits",
  "itunesitc",
  "itunesitl",
  "ivf",
  "ivonadat",
  "ivr",
  "ixalanceixs",
  "jackeddat",
  "jackgamesrf",
  "jacksumjacksum",
  "jagerencrypted",
  "jamcrackerjam",
  "janestre",
  "japanesef00",
  "jar",
  "jasakom",
  "jasspaemf",
  "javajad",
  "javaso",
  "jb2",
  "jbbahnscenery",
  "jbbahnvehicle",
  "jcreatorjcp",
  "jdpack",
  "jedijdbg",
  "jeffjif",
  "jetcvf",
  "jetdogsdat",
  "jeticobca",
  "jffs2",
  "jigdotemplate",
  "jigsawjig",
  "jnesjst",
  "jng",
  "jollyprintjps",
  "jpcrrjrsr",
  "jpeg",
  "jpeg2000codestream",
  "jralibraryjmg",
  "jtagjic",
  "juntador",
  "justcausesab",
  "justsystemsjex",
  "jwcadjwc",
  "kahootzktz",
  "kaleidescapetp4",
  "kandinskykmp",
  "karaboxmkf",
  "kasperskyavc",
  "kasperskydat",
  "kasperskydif",
  "kasperskydiff",
  "kasperskykdc",
  "kasperskykey",
  "kasperskyklq",
  "kasperskyklz",
  "kasperskylst",
  "kasperskyrpt",
  "katrinapos",
  "kawaisdf",
  "kbyspacker",
  "kc85tap",
  "kcemukct",
  "kchesskch",
  "kdmdesktop",
  "kdplayerkds",
  "keepasskdbx",
  "kegassx",
  "kexiskxs",
  "keyb0decryptor",
  "keymankvk",
  "keyshotbip",
  "keyshothdz",
  "kgb",
  "kgen98cfg",
  "kheopsksv",
  "khronosktx",
  "kicadbrd",
  "kicaddcm",
  "kicadlib",
  "kicadmod",
  "kicadpho",
  "kicadsch",
  "kicryptor",
  "kidpixkpx",
  "killdiskencrypted",
  "killingfloorrom",
  "kindletopazazw1",
  "kineticakdb",
  "kingtrackerfmk",
  "kirikiritlg",
  "kirikirixp3",
  "kirovcrypter",
  "kisskcf",
  "kkrunchy",
  "klystrackki",
  "klystrackkt",
  "kodakpt",
  "kolorkro",
  "komgamekom",
  "konamikss",
  "korgkmp",
  "korgksf",
  "korgnktrlset",
  "korgsng",
  "kotorncs",
  "kovter",
  "kretzvol",
  "kryofluxraw",
  "krypton",
  "ksaseed",
  "kugoukrc",
  "kurzweilkrz",
  "kwaj",
  "kwikdrawkwk",
  "kyoceraprn",
  "l0rdcrypter",
  "labviewctl",
  "labviewdat",
  "labviewllb",
  "labviewlvm",
  "labviewmnu",
  "labviewvi",
  "lamecrypt",
  "larp64",
  "laserdrwlyz",
  "lassidecarlasx",
  "laytoncbin",
  "laytoncfnt",
  "laytoncimg",
  "laytoncpck",
  "laytongds",
  "laytonmods",
  "laytonpcm",
  "lazpaintlzp",
  "lbr",
  "lccrypto",
  "ldrawldw",
  "leagueoflegendsanm",
  "leagueoflegendsskl",
  "leagueoflegendswad",
  "lecturnitylpd",
  "legasuitejwr",
  "legatolss",
  "legglesslme",
  "legorbf",
  "legorbt",
  "legorxe",
  "lexarlrs",
  "lexicrosspzl",
  "lexteklid",
  "lgepak",
  "lha",
  "lib",
  "lidare57",
  "lidarlas",
  "lightroomlprev",
  "lightscapelp",
  "lightwaveenv",
  "lightwavelwo",
  "lightwavelws",
  "lightwavemot",
  "lightweightlvf",
  "liko12lk12",
  "limbosbl",
  "lindenllm",
  "lindennotecard",
  "line6l6t",
  "lineage2l2r",
  "lingoesld2",
  "linkdevicedldi",
  "linksls",
  "linuxperf",
  "lipsyncgpo",
  "liquidh2o",
  "liquidliq",
  "liquidlqt",
  "listgeolgo",
  "lite32",
  "liveforspeedabc",
  "liveforspeedban",
  "liveforspeedcol",
  "liveforspeedcon",
  "liveforspeedeng",
  "liveforspeedgst",
  "liveforspeedhmn",
  "liveforspeedknw",
  "liveforspeedlgh",
  "liveforspeedlyt",
  "liveforspeedmpr",
  "liveforspeedobj",
  "liveforspeedpth",
  "liveforspeedrad",
  "liveforspeedset",
  "liveforspeedsmx",
  "liveforspeedspr",
  "liveforspeedwld",
  "llwgwgeo",
  "lmmc",
  "lnk",
  "locate32dbs",
  "lockedfileencrypted",
  "lodenetworkntw",
  "logicsimlsim",
  "logomotionlgf",
  "logoviewlvf",
  "logpos",
  "logtagltd",
  "lostdoor",
  "lotus123",
  "lotusadx",
  "lotusflg",
  "lotusfreeancedrw",
  "lotusfreelancecgm",
  "lotuslvf",
  "lotuslwp",
  "lotusmanuscriptdoc",
  "lotusnsf",
  "lotusorg",
  "lotuspic",
  "lotuspre",
  "lotusscm",
  "lotussmartsuiteifl",
  "lotuswk1",
  "lotuswk3",
  "lotuswk45",
  "lotuswks",
  "lrzip",
  "luabc",
  "lucasartslab",
  "lucasartslfd",
  "lulzcrypt",
  "lusypos",
  "lvl23n5crypter",
  "lz4",
  "lzhamcompresseddata",
  "lzip",
  "lzma",
  "lzop",
  "lzs",
  "macbinary",
  "macdrawdrw",
  "macdsstore",
  "macho32 big/bundle",
  "macho32 big/exe",
  "macho32 big/none",
  "macho32 big/so",
  "macho32 little/bundle",
  "macho32 little/core",
  "macho32 little/exe",
  "macho32 little/none",
  "macho32 little/so",
  "macho64 big/bundle",
  "macho64 big/exe",
  "macho64 big/none",
  "macho64 big/so",
  "macho64 little/bundle",
  "macho64 little/core",
  "macho64 little/exe",
  "macho64 little/none",
  "macho64 little/so",
  "macintoshpict",
  "macpef",
  "macromediacct",
  "macromediaclr",
  "macromediadcr",
  "macromediadjr",
  "macromediadxr",
  "macromediajsfl",
  "macromediaswa",
  "madagascarbld",
  "maddendat",
  "madonnamodelmmd",
  "madshag",
  "madtrackermt2",
  "magicavoxelvox",
  "magicavoxelxraw",
  "magiccameramce",
  "magicdrawmdr",
  "magickmpc",
  "magiclanterndiff",
  "magiclanternmlv",
  "magicqshw",
  "magicspr",
  "magixmvd",
  "magneticgfx",
  "magnetichnt",
  "magneticmag",
  "magneticsnd",
  "magniberencrypted",
  "makichanmag",
  "maliegfmgf",
  "malltycoonmuk",
  "malpacker",
  "malwarebytesdata",
  "mamechd",
  "mamesta",
  "mametaco",
  "maplempl",
  "mapletownml1",
  "mapsendwpt",
  "mapsforgeosm",
  "mapsourcegdb",
  "mapwindowlbl",
  "mar",
  "marcrypt",
  "mariokartkmp",
  "markiimii",
  "markiimk2",
  "marmosettbscene",
  "masimus",
  "maskpe",
  "masseffectme2headmorph",
  "massivepak",
  "mastercammc9",
  "mastercookmcf",
  "mastertrackermtr",
  "mathcadmcf",
  "mathematicanb",
  "matlabmat",
  "matrixencrypted",
  "matrixmtx",
  "maxcryptmaxc",
  "maxfilec3",
  "maxonb3d",
  "maxonc4d",
  "maxoncadmclib",
  "maxonl4d",
  "maxonmagichsn",
  "maxonprf",
  "maxonworddok",
  "maxres",
  "maxtraxmxtx",
  "maxwellmxm",
  "mayaiff",
  "mayama",
  "mayamb",
  "mayaswatches",
  "mbdiff",
  "mbox",
  "mbx",
  "mcmd",
  "mdb",
  "mdd",
  "mdf",
  "mds",
  "mechwarriorfit",
  "medalofhonorrez",
  "media container/dll",
  "media container/dos",
  "media container/exe",
  "media container/none",
  "media container/unknown",
  "media_container/none",
  "mediacontainermcf",
  "mediaforgexmfg",
  "mediaplayermpcpl",
  "mediasafeenc",
  "mediashowprod",
  "mediatekbin",
  "mediazipmzf",
  "mednafenmcm",
  "megacadmac",
  "megacadmtl",
  "megacadprt",
  "megapaintinf",
  "megapaintlib",
  "megapaintmod",
  "megapaintmpb",
  "megapaintpat",
  "megapaintpop",
  "megapainttrb",
  "megatrackermgt",
  "megazeuxmzm",
  "merinencrypted",
  "mesam2",
  "mesatbr",
  "mescalinebinder",
  "meshworkmesh",
  "messagebmg",
  "messengerpluspld",
  "messengerplusple",
  "messengerplusplp",
  "messengersqm",
  "messiahstudiompj",
  "messmfi",
  "metamediavem",
  "metasequoiamqb",
  "metasequoiamqo",
  "meteorologicalgrb",
  "mew",
  "mew5",
  "meyermgf",
  "mhtml",
  "miamigalgr",
  "microarraypcl",
  "microfocusgnt",
  "microfocuslbr",
  "micrografxdrw",
  "microsoftbcf",
  "microsoftbdr",
  "microsoftblkey",
  "microsoftblvolume",
  "microsoftbtr",
  "microsoftclb",
  "microsoftcmf",
  "microsoftdir",
  "microsoftdmp",
  "microsoftdsft",
  "microsoftdsis",
  "microsoftedb",
  "microsoftexcel",
  "microsoftffe",
  "microsoftgrl",
  "microsofthit",
  "microsoftiaf",
  "microsoftidentifier",
  "microsoftiedat",
  "microsoftilk",
  "microsoftjob",
  "microsoftkey",
  "microsoftlm",
  "microsoftmathgcw",
  "microsoftmdmp",
  "microsoftntbackup",
  "microsoftofficeencrypted",
  "microsoftofficexml",
  "microsoftpatchpa19",
  "microsoftpatchpa30",
  "microsoftpdb",
  "microsoftpif",
  "microsoftpowerpoint",
  "microsoftpublisher",
  "microsoftqpu",
  "microsoftquarantinefile",
  "microsoftreg",
  "microsoftregf",
  "microsoftsdb",
  "microsoftsft",
  "microsoftsis",
  "microsoftspl",
  "microsofttask",
  "microsofttlb",
  "microsofttoc",
  "microsoftvsd",
  "microsoftword",
  "microsoftwsuspsf",
  "microsoftxnb",
  "microstationlsl",
  "microstationm01",
  "microstationmat",
  "microstationpal",
  "microstationrsc",
  "midasmcb",
  "midi",
  "midimazemze",
  "midtownar",
  "mie",
  "miff",
  "miiarc",
  "mikmoduni",
  "mikrotiknpk",
  "mikrotikrif",
  "mikumikudancepmm",
  "milkshapems3d",
  "mime",
  "minimigcfg",
  "minitabmtp",
  "minitabmtw",
  "minivminibank",
  "minkecrypt",
  "miocompressormio",
  "miomotionmio",
  "miramonmmz",
  "misfitmm3d",
  "missionpat",
  "misterini",
  "mivascriptmvc",
  "mix",
  "mkfpacker",
  "mkv",
  "mkwactmkw",
  "mlatmad",
  "mmf",
  "mmfwsnd",
  "mng",
  "mnitransformxfm",
  "mny",
  "mobi",
  "mobibp",
  "mod2psg2psgmod",
  "modeldgf",
  "modulemod",
  "moldenogl",
  "molebox",
  "monkeyape",
  "monotonemon",
  "monucadmcd",
  "moogmodularamb",
  "moonbasecmp",
  "moonbasemb",
  "moonblastermw",
  "moondrivermdr",
  "moovempz",
  "mopfilemop",
  "mophunmpn",
  "morkdat",
  "morphmrf",
  "mortalkombatftr",
  "mortalkombatssf",
  "mosaichot",
  "mosesrat",
  "motionbvh",
  "motorolashx",
  "motorolaski",
  "mountandbladesav",
  "moviemagicmmsw",
  "moviemaker3cn",
  "moviemaker3mm",
  "moviemakervmm",
  "moviesetterprod",
  "movieshopext",
  "moviesworkshoplhts",
  "moxcelmxl",
  "mozartmz",
  "mozartmzp",
  "mozillaextension",
  "mozillamozlz4",
  "mp",
  "mpack",
  "mpg",
  "mpress",
  "mpu401mtk",
  "mqlex",
  "mrdark",
  "mrsidsid",
  "mrundetectable",
  "mrw",
  "mscnastranwm3",
  "msddiskddi",
  "msdeltadcd",
  "msdeltadch",
  "msdeltadcm",
  "msdeltadcn",
  "msdeltadcs",
  "msdeltadcx",
  "msebookreaderlit",
  "msflightcfg",
  "msi",
  "msonenoteone",
  "msoutlookfav",
  "msoutlooknk2",
  "mspaintmsp",
  "msquickbasic",
  "msremotedesktoprdp",
  "msvtrackerins",
  "mswindowsmediawmdb",
  "msxcassettecas",
  "msxmig",
  "msxprotrackerpro",
  "msxsbk",
  "msxsbm",
  "mtf",
  "muckiprotector",
  "muibuildermuib",
  "multibitcheckpoints",
  "multibitinfo",
  "multibitkey",
  "multibitspvchain",
  "multibitwallet",
  "multimediabuildermbd",
  "multisim",
  "multitrackermtm",
  "musfile",
  "musiceditormed",
  "musiclineml",
  "musicmakerip",
  "musicmakermm8",
  "musicmatchmvs",
  "musicnotationabc",
  "musxmusx",
  "mutationmaf",
  "mvxmodulemvm",
  "mxf",
  "mybasenyf",
  "mylifeorganizedml",
  "myphoneexplorermbp",
  "myriadharmonymus",
  "mysqlfrm",
  "mysqlmyi",
  "mythtvnuv",
  "mz/archive",
  "mz/dos",
  "mzcrypt",
  "mzresource",
  "n1n1n1encrypted",
  "naivebitmap",
  "nakedbind",
  "nakedpack",
  "nanozipnz",
  "nasacdf",
  "nasaimq",
  "nasalbl",
  "nascarcar",
  "nascargar",
  "nascarmas",
  "nascarscn",
  "nascartex",
  "nascartrk",
  "nativeinstrumentsbnk",
  "natonsf",
  "natronnps",
  "navisworksnwd",
  "naviteln3o",
  "navitelntm",
  "navitercub",
  "nbinder",
  "ncbisff",
  "ncbiztr",
  "ncd",
  "nearlyrawnrrd",
  "neatimagenfp",
  "neatvideodnp",
  "neatvideonfp",
  "nebulan2p",
  "nebulosacripter",
  "necromancerdlg",
  "nefilimencrypted",
  "nekon",
  "neobookpub",
  "neocontentnwp",
  "neodesknic",
  "neolite",
  "neopaintpal",
  "neopaintprd",
  "neopleimg",
  "neoplepacknpk",
  "nerdtrackerned",
  "nestopianst",
  "netbeansnps",
  "netcdfcdl",
  "netcdfnc",
  "neteasenpk",
  "netfabbfabbproject",
  "netgenvol",
  "netimmersenif",
  "netmoncap",
  "netstumblerns1",
  "netwaremsg",
  "netwarenlm",
  "neuratronopt",
  "neuroexplorernex",
  "neuroscanast",
  "neuroscancnt",
  "nextimg",
  "nextstartwst",
  "nexusnex",
  "nfo",
  "nfsabk",
  "nfsbundle",
  "nfslzc",
  "ngbinderpro",
  "ngisdted",
  "nhtsauds",
  "niceprotect",
  "niftinii",
  "nikonncp",
  "nikonnop",
  "nimblegenndf",
  "nimblegenngd",
  "nintendobfsar",
  "nintendochiptunensfe",
  "nintendods2sflib",
  "nintendonarc",
  "nintendonsf",
  "nintendothp",
  "nistsph",
  "nitf",
  "nitroarchive",
  "njstarnjx",
  "nme",
  "nocashgbasav",
  "nod32dat",
  "nod32lic",
  "nod32nqi",
  "nod32nupnosign",
  "nod32nupsigned",
  "noisetrekkerntk",
  "nokianbu",
  "nokiangg",
  "nokianlm",
  "nokianol",
  "nokianpm",
  "nokianrw",
  "nokiansl",
  "nokiaxmf",
  "nolimitsnl2park",
  "nolimitsnltrack",
  "nomadsnpk",
  "none/dll",
  "none/dos",
  "none/executable",
  "none/html",
  "none/none",
  "none/relocatable",
  "none/vxd",
  "nonopocketngb",
  "nonpareilmod",
  "nordstagensmp",
  "nordstagenspg",
  "nordstagepch2",
  "normalitydas",
  "nortonbackup001",
  "nortondat",
  "nortonncd",
  "notesop",
  "noteworthynwc",
  "novalite",
  "novastormmediafile",
  "novelldosmsg",
  "novellerrordat",
  "novellins",
  "novellnab",
  "novotradentp",
  "npack",
  "npws",
  "nra",
  "nrg",
  "nri",
  "nsis",
  "nspack",
  "nsv",
  "ntfmapfilentf",
  "ntitlernt",
  "ntrqsav",
  "nuclearrat",
  "nucleotideemb",
  "nufxbxy",
  "nufxshk",
  "nuget",
  "numpynpy",
  "nuppelnuv",
  "nurfcryptor",
  "nut",
  "nutsmac",
  "nvc",
  "nwcc",
  "nwipernw",
  "nwjs",
  "nxransomwareencrypted",
  "obisynthosp",
  "obitusdat",
  "objectgraphicsogl",
  "oblivioness",
  "obrix",
  "obsidium",
  "obsidiumopf",
  "ocamlcma",
  "ocamlcmi",
  "ocamlcmo",
  "ocamlcmx",
  "ocamlcmxa",
  "ocplaycfg",
  "octamedmmd",
  "odex/exe",
  "ogg",
  "oggopus",
  "oktalyzerokta",
  "ole1.0",
  "olitextotx",
  "ollydbgudd",
  "olpc565",
  "olympusorf",
  "omnipagemet",
  "omnipassopf",
  "onlinetvrotr",
  "ontx",
  "ooktrackertoast",
  "opencolorioocio",
  "opendocumentchart",
  "opendocumentdatabase",
  "opendocumentformula",
  "opendocumentgraphics",
  "opendocumentimage",
  "opendocumentmaster",
  "opendocumentpresentation",
  "opendocumentspreadsheet",
  "opendocumenttext",
  "opendocumentwebpage",
  "opendwginit",
  "openehradl",
  "openfinancialofx",
  "openofficedatabase",
  "openofficeformula",
  "openofficegraphics",
  "openofficehtml",
  "openofficemaster",
  "openofficepresentation",
  "openofficespreadsheet",
  "openofficetext",
  "opensslenc",
  "opentechpgm",
  "opentimestampsots",
  "openttdsav",
  "openzim",
  "operaadr",
  "operaextension",
  "optimfrogofr",
  "optix",
  "opvaultformat",
  "oraclefmb",
  "oraclejks",
  "oracletrm",
  "orcadmax",
  "orcadopj",
  "orderofwarpkg",
  "organyaorg",
  "orgplusopx",
  "oricdsk",
  "orictap",
  "oricutronsna",
  "originogo",
  "originopj",
  "orionsamplerosp",
  "ortimzeitob3",
  "os2bmp",
  "os2cur",
  "os2ico",
  "os2msg",
  "ost",
  "osuscriptosu",
  "otsomx",
  "otssetup",
  "outlookembeddedmsg",
  "outlookmsg",
  "ovationdpd",
  "oxygenosm",
  "oziexplorerevt",
  "oziexplorermap",
  "oziexplorerplt",
  "oziexplorerrte",
  "oziexplorerwpt",
  "ozoneapp",
  "p64fluxp64",
  "pab",
  "pablopaintpa3",
  "pack200",
  "package/none",
  "packman",
  "pagefocusdve",
  "pagestreampgs",
  "paintnetpdn",
  "paintproppp",
  "paintshopprojbf",
  "paintshoppropal",
  "paintshoppropsp",
  "pal",
  "palladixplx",
  "palmdb",
  "palmpilot",
  "palmpilotcsm",
  "pamdevelopmentwad",
  "panasonicdb",
  "panasonicrw2",
  "panasonicvm1",
  "pandora",
  "pandorarat",
  "panoramaset",
  "panzerelitex",
  "paperportfss",
  "paperportmax",
  "papyruspap",
  "papyruspri",
  "paqcompressorpaq",
  "paradoxdb",
  "paradoxmb",
  "paradoxpuf",
  "parajvejverom",
  "parchivepar",
  "parchivepar2",
  "partcloneimg",
  "partimageimg",
  "pascaltph",
  "pascaltpu",
  "pascalu",
  "passmarkpt",
  "passwordbosspwb",
  "passwordboxdat",
  "passworddepotpsw",
  "passwordpsafe3",
  "pastiimagestx",
  "patchmeisterpmdriver",
  "patriciancpr",
  "pc64cfg",
  "pc64file",
  "pcanywhereap6",
  "pcanywherebhf",
  "pcanywherechf",
  "pcap",
  "pcapng",
  "pcf",
  "pclosilk",
  "pcmsox",
  "pcrastermap",
  "pcshrinker",
  "pcstichpat",
  "pcstoryboardfac",
  "pcx",
  "pdf",
  "pdidiskimagepdi",
  "pe+/.net dll",
  "pe+/.net exe",
  "pe+/dll",
  "pe+/exe",
  "pe+/sys",
  "pe+/uefi",
  "pe+/xbox",
  "pe/.net dll",
  "pe/.net exe",
  "pe/dll",
  "pe/exe",
  "pe/sys",
  "pe/uefi",
  "pe/vxd",
  "pe/xbox",
  "pe123",
  "pe16/archive",
  "pe16/dll",
  "pe16/exe",
  "pe16/executable",
  "pe16resource",
  "pe32+/dll",
  "pe32+/executable",
  "pe32/dll",
  "pe32/executable",
  "pe32/vxd",
  "peachcalccal",
  "peazippea",
  "pebblepdc",
  "pebundle",
  "pecancer",
  "pecloak",
  "pecompact",
  "pediminisher",
  "pemangle",
  "peninja",
  "pepack",
  "pepasswordprot",
  "pepe2dsp",
  "pepsi",
  "pequake",
  "peresource",
  "performfpk",
  "perplexprotector",
  "personalfontdef",
  "personalfontmcr",
  "peshield",
  "pesimg",
  "pespin",
  "pestpatroldat",
  "petite",
  "pex",
  "pezip",
  "pf",
  "pfdcdiskimagepfdc",
  "pfswritedoc",
  "pgf",
  "pgpasc",
  "pgpdiskpgd",
  "pgpdiskstr",
  "pgpdiskzip",
  "pgpprivkey",
  "pgppubkey",
  "pgpsig",
  "phaseoneiiq",
  "philipsdrm",
  "phobosencrypted",
  "phoenixbmp",
  "phoenixdds",
  "phoenixrcpxf",
  "phoenixsim",
  "phonebookpbb",
  "photocdpcd",
  "photodexpsh",
  "photofiltrepfd",
  "photofiltrepfi",
  "photofiltrepfv",
  "photolineplb",
  "photolinepld",
  "photomergepmg",
  "photoparade4pp",
  "photoshopabr",
  "photoshopacb",
  "photoshopcsh",
  "photoshopgrd",
  "photoshopp3e",
  "photoshoppat",
  "photoshopshc",
  "photostudiopsf",
  "phredphd",
  "physicseditorpes",
  "piccolineimg",
  "picoquantphu",
  "picoquantptu",
  "picryptor",
  "picturebxu",
  "piecewisepwc",
  "pimcompressedpim",
  "pingplotterpp2",
  "pingplotterppx",
  "pingvincrypt",
  "pioneerlkd",
  "pipacker",
  "pismopfo",
  "pistoncollageptcop",
  "pistoncollagepttune",
  "pixartpix",
  "pixclpal",
  "pixclpbl",
  "pixelformerpxf",
  "pixelmatorpxm",
  "pixiapxa",
  "pixieok",
  "pixiepxi",
  "pixilangpixicode",
  "pklav",
  "pklite",
  "planepmbc",
  "platinenbib",
  "playmationact",
  "playmationatt",
  "playmationcho",
  "playmationfig",
  "playmationsp",
  "playmationsur",
  "playstation4pkg",
  "playstationgim",
  "playstationmax",
  "playstationp3t",
  "playstationpak",
  "playstationpbp",
  "playstationpfd",
  "playstationpmf",
  "playstationpmp",
  "playstationpsarc",
  "playstationpsf",
  "playstationpup",
  "playstationrsd",
  "playstationsdf",
  "playstationseq",
  "playstationsfo",
  "playstationvab",
  "playstationvag",
  "plcdatafilevd",
  "plexonpl2",
  "plexonplx",
  "pma",
  "pmd",
  "pmdrawpmd",
  "pmvxpm",
  "png",
  "pnm",
  "pocketbookpbt",
  "pockettanksbbk",
  "pockettanksemi",
  "pohernah",
  "poisonivy",
  "pokecrypt",
  "polybox",
  "polychromeprf",
  "polytrackerptm",
  "ponyproge2p",
  "portablebridgepbn",
  "portfoliopgx",
  "portilabpolys00",
  "portofcalltrp",
  "postalgamesak",
  "postscriptppd",
  "powerarchiverpae",
  "powerbasicpb",
  "powerbasicpbh",
  "powerbtd",
  "powerbuilderpbl",
  "powerpackerpp",
  "powertrackerpt",
  "powertranslatormtp",
  "powerupalb",
  "powervrtexturepvr",
  "powerwindowspw",
  "powerworddic",
  "ppmzcompresseddata",
  "pprintima",
  "praatprapic",
  "premiereptl",
  "pretator",
  "preygamesave",
  "primaveraxer",
  "printpartnerfon",
  "printshopply",
  "prismpnt",
  "prisonerkro",
  "privatepersonalpacker",
  "processmonitorpml",
  "proengineerasm",
  "proengineerdrw",
  "proengineerfrm",
  "proengineerprt",
  "proengineersec",
  "profexamexam",
  "proficadppd",
  "projectigires",
  "prolinepvd",
  "promosoftfbf",
  "promusicpvi",
  "promusicpzi",
  "propellerheadrbs",
  "propellerheadremotemap",
  "propellerheadrfl",
  "propellerheadrns",
  "propellerheadrps",
  "propellerheadrx2",
  "propellerheadsx2",
  "propilkkidat",
  "prorunnerpru2",
  "prospacepsa",
  "protecteddiskpdi",
  "protelschlib",
  "protobufpbf",
  "protrackermod",
  "protrackerpsm",
  "protrackerpt3",
  "protrackerpt36",
  "protrekkr2ptk",
  "ps",
  "psd",
  "psionagn",
  "psionaif",
  "psionals",
  "psionapp",
  "psiondbf",
  "psiondyl",
  "psionfnt",
  "psionimg",
  "psionipk",
  "psionmbm",
  "psionopk",
  "psionopo",
  "psionpic",
  "psionsis",
  "psionsketch",
  "psionspr",
  "psiontcr",
  "psionwrd",
  "psionwve",
  "psitreeconf",
  "psmodulepsm",
  "pst",
  "psvitacaf",
  "psvitakeystone",
  "psvitasealedkey",
  "psychonautspkg",
  "psyclepsy",
  "ptccreomtl",
  "ptcengineerprt",
  "ptciges",
  "puavohardphpimc",
  "puavohardphpimci",
  "punisherrat",
  "puppetmasterrat",
  "puzzleviewpvp",
  "pwrdevvd",
  "py2exeinstaller",
  "pyinstaller",
  "pythonpyc",
  "pyz",
  "qandadoc",
  "qcow",
  "qed",
  "qemacsfontfbf",
  "qemulatormdv",
  "qlfcgq",
  "qlikviewqvw",
  "qpressqp03",
  "qtinstaller",
  "qtqm",
  "quadracomposeremod",
  "quakeaas",
  "quakebsp",
  "quakelit",
  "quakemd2",
  "quakemd3",
  "quakendm",
  "quakepak",
  "quakewad",
  "qualcommqcp",
  "quantumpak",
  "quarkexpress",
  "quarkimmediaimd",
  "quartuscsf",
  "quartusdbinfo",
  "quartusfsf",
  "quartusjcf",
  "quartuspof",
  "quartusqws",
  "quartussof",
  "quartusssf",
  "quick3dq3o",
  "quickbatchfilecompiler",
  "quickcad",
  "quickdraw3dm",
  "quickdraw3dmf",
  "quickenqdf",
  "quickenqel",
  "quickenqif",
  "quickenqsd",
  "quicklinkqfx",
  "quickpack",
  "quicktime",
  "quilldoc",
  "quiltblk",
  "quintusani",
  "r1m",
  "ra",
  "radcorercf",
  "raddeveloperrad",
  "raddeveloperrcs",
  "radixdat",
  "raf",
  "ragepackagerfp",
  "ragnarokvdk",
  "ragtimertd",
  "raichrhf",
  "ramtrackertrk",
  "rar",
  "rarc",
  "ras",
  "rastermrf",
  "ratholerhl",
  "ratpacker",
  "raw",
  "rawvox",
  "rawzorrwz",
  "raysmda",
  "rbinaryrdx2",
  "rcastudiost2",
  "rcfile",
  "rcryptor",
  "rdf",
  "reactionrd",
  "reactionrxn",
  "realarcadergs",
  "realbasicrbp",
  "realcaddrcad",
  "realdrawrdw",
  "realityadlibtrackerrad",
  "realram",
  "realtrackerrtm",
  "realworldrli",
  "reaperreapeaks",
  "reaperrpp",
  "reasonsong",
  "rebelmvs",
  "rebelpcs",
  "rebelrb2",
  "recoloredrcl",
  "recordingxferd",
  "redalertra3replay",
  "redcoder3d",
  "redfactioniipeg",
  "redhackercrypter",
  "redsectorvec",
  "redtitanrtz",
  "reflexr2d",
  "regcleanerrlg",
  "regressirw3",
  "rekorkp",
  "relicrsh",
  "remcos",
  "remotekeysrkp",
  "renderwarerwx",
  "renoisetrackerrns",
  "renpyrpa",
  "renpyrpyc",
  "rescorxf",
  "resourcercl",
  "reversinglabs",
  "revolutionrev",
  "rgbe",
  "rhino3dm",
  "rhinocerosstl",
  "rhinorws",
  "richardsbridgepbn",
  "rigakuras",
  "riotraf",
  "riptermfnt",
  "risingmdat",
  "rix",
  "rletre",
  "rlpack",
  "rmf",
  "rmid",
  "rmmp",
  "rmp3",
  "rnc",
  "robinsonrttex",
  "rocketbookrb",
  "rolandrlg",
  "rolandsvd",
  "roq",
  "rottlevelfile",
  "royalheroescar",
  "rpgmakerldb",
  "rpgmakerlmt",
  "rpgmakerlmu",
  "rpm",
  "rtencoderrte",
  "rtf",
  "ruleofroserpk",
  "rumblensz",
  "rumbleofroses",
  "runesofmagicfdb",
  "russiancryptor",
  "rzip",
  "sacdtoc",
  "sacred2sacred2save",
  "safeguarduti",
  "safengine",
  "sagebackup000",
  "sageencrypted",
  "salsaencrypted",
  "sampboxsmp",
  "sampletank2ikmp",
  "samplevisionsmp",
  "samplituderap",
  "samplitudevip",
  "samsamencrypted",
  "samtoolsbcf",
  "samtoolscram",
  "samtoolscsi",
  "samtoolstabix",
  "sangduckcmf",
  "sangduckspr",
  "sap2000sdb",
  "sapadsadd",
  "sas7bdat",
  "sasinstitutesd2",
  "sasinstitutexpt",
  "satoricvs",
  "savageanm",
  "sawcrypter",
  "sbcarchiversbc",
  "sbstudiopac",
  "sc2gearssmpd",
  "scap",
  "schwarzesonne",
  "scidsi4",
  "scidsn4",
  "sckillsav",
  "scoobydoommp",
  "scpecgscp",
  "screamres",
  "screamtrackers3m",
  "screamtrackerstm",
  "screenswiftssp",
  "scriptbasicbbf",
  "scrullsmf",
  "sct",
  "sculptscene",
  "scummvmini",
  "sdemulatorhfe",
  "sdf",
  "sdif",
  "sdtsddf",
  "sea",
  "seal2s2a",
  "seammat",
  "seams3d",
  "secupack",
  "secureshade",
  "seeyoucmr",
  "seeyoundb",
  "segaadx",
  "segafilm",
  "segagym",
  "segasgc",
  "segavgm",
  "semsnapshotsem",
  "sensiblegolf000",
  "sepack",
  "sequencegenbank",
  "sequencerone",
  "setoolssw",
  "settingcontent",
  "settlerss2m",
  "settlersswd",
  "setupfactory",
  "sfk",
  "sfwjpeg",
  "sfxcalc",
  "sgi",
  "sgiyaodlydl",
  "sgo",
  "sgriddler",
  "shaketrackerst",
  "shandasnb",
  "shapefileprj",
  "shaperlut3dl",
  "shareazadat",
  "sharkportsps",
  "shelxres",
  "shock2res",
  "shrinkwrap",
  "siagofficesiag",
  "sibeliussib",
  "sid",
  "sidplaysid",
  "siegfrieddata",
  "siegfriedsig",
  "siemensseclt",
  "siemensseobj",
  "siemensseroot",
  "siemenssesseg",
  "siemenssettab",
  "sietronicscpi",
  "signplotsp",
  "sigprocfil",
  "silenthillarc",
  "silkbms",
  "silkexplorerpex",
  "silkroadban",
  "silkroadbms",
  "silkroadbsr",
  "silkroadddj",
  "silkroaddof",
  "silkroadefp",
  "silkroadnvm",
  "silo3dsib",
  "silolibsilo",
  "silverlight",
  "silversrc",
  "simantant",
  "simbioz",
  "simisace",
  "simplepack",
  "simpleplanescompspmod",
  "simpleplanesspmod",
  "sims2pack",
  "sims3pack",
  "simsfar",
  "simsiff",
  "simutranspak",
  "sinclairscl",
  "singlefilesystemsfs",
  "sit",
  "sixxpack",
  "sjdatabasecdb",
  "skaletrackerskm",
  "skdundetectabler",
  "skincrafterskf",
  "skp",
  "skunnylid",
  "skypedat",
  "skypeezlog",
  "skypemls",
  "slamdbsdx",
  "slamdbtdb",
  "slh",
  "slightatarisap",
  "slimshowss",
  "slixss",
  "slubmanplg",
  "slvc0deprotector",
  "smacdatasma",
  "smartcamsmf",
  "smartdrawsdr",
  "smartgraphstm",
  "smartinstallmaker",
  "smartinstallsmm",
  "smartsniffssp",
  "smartworkpcb",
  "smokescrypt",
  "smtp",
  "snagitsnag",
  "snapadf",
  "snapgraphix",
  "snapshotsnx",
  "snarkpack",
  "sndtoolsndt",
  "snesspc",
  "snesunif",
  "snm",
  "snnscfg",
  "snnsnet",
  "snnspat",
  "snnsres",
  "snoopcap",
  "snooptracesnoop",
  "snzipsnappy",
  "softdiskctx",
  "softimagescn",
  "softimagexsi",
  "softwarecompress",
  "sol",
  "solaceheliossvh",
  "solacesvt",
  "solarispkg",
  "soldatbot",
  "solitairessp",
  "somerasgf",
  "sonarcsnc",
  "songhmi",
  "sonicarrangerinstrument",
  "sonicarrangersa",
  "soniquesgf",
  "sonyoma",
  "sonysoundforgesfi",
  "sophosvdb",
  "sordm5cas",
  "sosimapsos",
  "sothinklmk",
  "soundbanksf2",
  "soundblasteribk",
  "soundclubsn2",
  "soundeffectsee",
  "soundfxtrackersfx",
  "soundtrackerst26",
  "sourceani",
  "sourcemdl",
  "sourcephy",
  "spaceyesspv",
  "sparkupspk",
  "sparkyucsf",
  "spazio3ds3d",
  "spec",
  "speccysxg",
  "spectralspa",
  "spectrapaintstencil",
  "spectrasuiteprocspec",
  "spectrumtzx",
  "speculatorzx82",
  "speechlabnsp",
  "speechlabsd",
  "speedtreespt",
  "speedviewspmo",
  "speedyss",
  "spellboundpak",
  "spiderbinder",
  "spidermanwbk",
  "spif",
  "splanspl",
  "splashidvid",
  "splayer",
  "splinesfd",
  "sporesspo",
  "springsmf",
  "springsmt",
  "spss",
  "spsstabletlo",
  "spsstemplatesct",
  "spynet",
  "sq",
  "sqlite",
  "sqlitewriteaheadlog",
  "sqlwindowsapp",
  "sqlwindowsapt",
  "squarecsw",
  "squareenixscd",
  "squashfs",
  "sqx",
  "sshkey",
  "sshkeykrl",
  "st6astrocamerast6",
  "stadenscf",
  "stadpac",
  "star3st3",
  "starboundplayer",
  "starcraftrep",
  "starcraftscm",
  "stardictifo",
  "stardockdream",
  "starkossks",
  "starlinksdf",
  "starlogoslogo",
  "starlogosltng",
  "starofficesdg",
  "starsagagam",
  "starsiegemis",
  "starsiegevol",
  "starskyhutchwad",
  "startrekkernt",
  "starviewsvm",
  "starwarstre",
  "starwritersdw",
  "statadta",
  "statagraphgph",
  "statisticascr",
  "statisticasta",
  "statisticastg",
  "statlerqli",
  "steamupk",
  "stepmaniacrs",
  "stkgd",
  "stockholmstk",
  "stonecrackerstc",
  "stonepacker",
  "storagecraftspf",
  "storybookswd",
  "stosbas",
  "stosmbk",
  "streamstl",
  "strikecommanderiff",
  "studentwritinglt",
  "stuntsdat",
  "stuntsglb",
  "stuntsrepl",
  "stuntstrack",
  "suddenaps",
  "sunjcejceks",
  "sunplusbrn",
  "suntaac",
  "suntronicsun",
  "sunvoxsunsynth",
  "sunvoxsunvox",
  "supercalccal",
  "supercrypt",
  "superjaminstrument",
  "superjamkeyboard",
  "superjampatch",
  "superjamsong",
  "superrepsrep",
  "supersonicpiz",
  "supertuxstsg",
  "surfsbin",
  "surpriseadlibsat",
  "svg",
  "svkprotector",
  "sweetscape1bk",
  "swf",
  "swishswi",
  "swordsshipsection",
  "sybaseadt",
  "sygicpak",
  "sylarat",
  "sylk",
  "symantecdtf",
  "symantecgrd",
  "symantecmqbd",
  "symantecopn",
  "symantecqaidx",
  "symantecqaqwt",
  "symantecqbd",
  "symantecqbi",
  "symantecvbn",
  "symbianrsc",
  "symbosdox",
  "symbosexe",
  "symboshlp",
  "symbossgx",
  "symbosskm",
  "symbosvid",
  "symphoniesymmod",
  "synderplayersng",
  "synthesissyn",
  "syntrackersynmod",
  "syzygyrtbw",
  "syzygyrtbz",
  "szdd",
  "t98nfd",
  "tads2gam",
  "tads3t3",
  "tangoprolib",
  "taquarttip",
  "tar",
  "targetexpressmte",
  "taxactat",
  "taxmanrsdk",
  "tcbtrackertcb",
  "tcruisetcd",
  "tdiformattxt",
  "teamviewertvc",
  "teamviewertvs",
  "teckittec",
  "tecplotlpk",
  "tektronixisf",
  "tektronixwfm",
  "telematetms",
  "telmactmc",
  "tempustwd",
  "term95scx",
  "terminalrealitypod",
  "terminfotic",
  "terrabyteloc",
  "terragenatm",
  "terragensrf",
  "terragenter",
  "terragentgo",
  "terragentgw",
  "terrariatmod",
  "teslacryptencrypted",
  "testdrivetmf",
  "text/acrobat javascript",
  "text/actionscript",
  "text/ada",
  "text/archive",
  "text/assembly",
  "text/autohotkey",
  "text/autoit",
  "text/batch",
  "text/ccpp",
  "text/clojure",
  "text/cmake",
  "text/coffeescript",
  "text/common lisp",
  "text/csharp",
  "text/css",
  "text/d",
  "text/dart",
  "text/ebm",
  "text/eiffel",
  "text/emacs lisp",
  "text/erlang",
  "text/excel4",
  "text/factor",
  "text/fortran",
  "text/fsharp",
  "text/go",
  "text/groff",
  "text/groovy",
  "text/haskell",
  "text/html",
  "text/java",
  "text/javascript",
  "text/jscript",
  "text/json",
  "text/llvm",
  "text/lua",
  "text/makefile",
  "text/matlab",
  "text/nix",
  "text/none",
  "text/objective-c",
  "text/objective-j",
  "text/ocaml",
  "text/pascal",
  "text/perl",
  "text/perl6",
  "text/php",
  "text/powershell",
  "text/prolog",
  "text/puppet",
  "text/python",
  "text/r",
  "text/ruby",
  "text/rust",
  "text/scala",
  "text/scheme",
  "text/shell",
  "text/smalltalk",
  "text/smarty",
  "text/swift",
  "text/tcl",
  "text/tex",
  "text/typescript",
  "text/unknown",
  "text/vba",
  "text/vbs",
  "text/verilog",
  "text/vhdl",
  "text/viml",
  "text/visual basic",
  "text/webextensions javascript",
  "text/xml",
  "textmakertmd",
  "textpipefll",
  "textplustxp",
  "textresource",
  "textworksacf",
  "textworksbtx",
  "textworksdbo",
  "textworksdbr",
  "textworksdbs",
  "textworksixl",
  "textworksocc",
  "textworkssdo",
  "textworkstba",
  "textworkstbm",
  "tfmmusicmaker2tfe",
  "thebestcryptor",
  "thedrawpascalimm",
  "theelitedangerousovl",
  "theendoftheworldcrypter",
  "thegraphicsstudiodat",
  "themeengineuskn",
  "themida",
  "theplayerp",
  "thewitchersav",
  "thewitcherw2ent",
  "thiefwgs",
  "thinedgem15",
  "thinmanagerdb",
  "thinstall",
  "thomsonbin",
  "thomsonsap",
  "thunderbolt",
  "thunderbytekey",
  "thxtrackerins",
  "ti8xcalculator",
  "tiemuskn",
  "tiencr",
  "tiff",
  "timegaterwd",
  "timeshifttsv",
  "tinatsc",
  "tinkerplotstp",
  "tinspiretnc",
  "tinspiretno",
  "tinspiretns",
  "tinspiretnsp",
  "tinyloader",
  "tinypos",
  "tiworkbooktii",
  "tk3ebooktk3",
  "tksolvertk",
  "tnef",
  "tntmipsrvc",
  "tomatoarmcfg",
  "tommysoftwarempg",
  "tommysoftwaretlv",
  "tomtomdat",
  "tomtomstr",
  "topocadpxy",
  "topodat",
  "topsolidtopprj",
  "torrent",
  "totalannihilationfbi",
  "totalannihilationhpi",
  "totwmdl",
  "totwppt",
  "touhoudat",
  "tplotplt",
  "tracesscenetrace",
  "trackeraon",
  "trackerast",
  "trackeremod",
  "trackergdm",
  "trackerpackertp3",
  "trackmakergtm",
  "trackvistrk",
  "tradewindssav",
  "traincontrolleryrr",
  "trcziptrc",
  "treasurehuntpos",
  "treedbnotestreedb",
  "treesheetscts",
  "trendmicroptn",
  "trendybinder",
  "tricksternri",
  "trimtr5",
  "tripodjob",
  "truepainttpa",
  "truevisiontga",
  "tsonlinedat",
  "tsonlinedcd",
  "tssaudio",
  "tsunamirlb",
  "tta",
  "ttf",
  "ttpodtsk",
  "tuliptlp",
  "tundratnd",
  "turbocdsk",
  "turbodebuggertd2",
  "turbomodulasym",
  "turbopascaldsk",
  "turbopascalhlp",
  "turbopascaltp",
  "turboprinttpm",
  "turbosilverscr",
  "turbotax",
  "turbotax3pe",
  "turkojanrat",
  "turtlebeachpbf",
  "twinvqvqf",
  "twistedmetaldpc",
  "twistedmetaltms",
  "twistedmetaltpc",
  "tycoonovl",
  "tycoonzoo",
  "tzif",
  "ucscbed",
  "ucscchain",
  "ucscmaf",
  "ucscnet",
  "ucscwig",
  "udf",
  "ufocapturedat",
  "uha",
  "ukashencrypted",
  "uleadsmp",
  "uleadtpl",
  "uleadupd",
  "ultimoprimopss",
  "ultratrackerult",
  "unblockupcencrypted",
  "undergroundcrypter",
  "undetector",
  "uniquesmp",
  "unirasturf",
  "unityfsbundle",
  "unityupp",
  "universal",
  "universaldatalink",
  "unixbdf",
  "unknown/unknown",
  "unkowncrypter",
  "unnamedscrambler",
  "unrealpsk",
  "unrealutx",
  "upx",
  "upxlock",
  "upxmutanter",
  "upxmutatner",
  "usbuf2",
  "usgsdoq2",
  "uue",
  "vallentra",
  "valvebsp",
  "valvevpk",
  "valvevtf",
  "valvevvd",
  "vangoghcrypter",
  "vanguard",
  "varbitmapvbf",
  "variocamirb",
  "vaultyvdata",
  "vba32udb",
  "vbdosbas",
  "vbe",
  "vbincontainervbin",
  "vbs2exe",
  "vbsedit",
  "vcalendarvcs",
  "vcardvcf",
  "vcdimagervcd",
  "vcrypt",
  "vdi",
  "vectordeanins",
  "vectordeanrjp",
  "vectorfieldoommf",
  "vectormapcxf",
  "vectorsvf",
  "vectorworksvwx",
  "vectrexgam",
  "vektordrv",
  "vellumvlm",
  "velvetstudioams",
  "ventrilovrf",
  "veryordinaryvort",
  "vgcrypt",
  "vgmmusicmakervge",
  "vhd",
  "vhdx",
  "vicarmap",
  "vicspy",
  "video/archive",
  "video/none",
  "video/unknown",
  "videocreatorvid",
  "videomastervid",
  "videosanm",
  "videoser",
  "viff",
  "virtualcdvbl",
  "virtualdjvdj",
  "virtualgamevgs",
  "virtualmachinepwk",
  "virtualtiskn",
  "virtuanesvmv",
  "virtviewervv",
  "visicadwkf",
  "visiformvft",
  "visitor3pwe",
  "vissimv3d",
  "vistabootskin",
  "vistacamerascript",
  "vistadem",
  "vistaprov4s",
  "visualboyvbm",
  "visualinstaller",
  "visualizerdmo",
  "visualizerv3d",
  "visuallispvlx",
  "visualparadigmvpp",
  "visualschnauzerp7",
  "visualstudiodsp",
  "visualstudiodsw",
  "visualstudiopch",
  "visualstudioproj",
  "visualstudiosln",
  "visualstudiovsz",
  "visualtabletekb",
  "vivaldibin",
  "vivastory",
  "vividasviv",
  "vivoviv",
  "vmdk",
  "vmprotect",
  "vocaleyeshlp",
  "vocaloidvmd",
  "volitionvp",
  "vortexencrypted",
  "vortexvt2",
  "voxelvxl",
  "voxlapanim",
  "voxlapkfa",
  "voxlapkv6",
  "vpacker",
  "vphybridcadrvd",
  "vsamplervsb",
  "vskimmerpos",
  "vtbuilderbt",
  "vuforiaqcar",
  "vuzefilevuze",
  "vxdresource",
  "vz200vz",
  "wab",
  "wafadrivewdr",
  "waixingwxn",
  "waltoptop",
  "wangwvd",
  "wannacryencrypted",
  "wapbookmarkvbm",
  "warc",
  "warcraftdoo",
  "warcraftm2",
  "warcraftmdx",
  "warcraftpud",
  "warcraftw3e",
  "warcraftw3g",
  "warcraftw3m",
  "warcraftwpm",
  "wasm",
  "wav",
  "wavefrontmtl",
  "waveliwc",
  "wavezipmcp",
  "wavpackwv",
  "weaponweap",
  "weatherlinkwlk",
  "weathertoolwea",
  "webexarf",
  "webexwrf",
  "webm",
  "webp",
  "webshotswb",
  "webshotswbc",
  "webvideovtt",
  "wechataud",
  "werescdtc",
  "westmeadeeg",
  "westwoodbag",
  "westwoodvqa",
  "westwoodwar",
  "whereisitctf",
  "whisper32wsp",
  "whitellcrypt",
  "wibuwibucmrau",
  "wiibreff",
  "wiibrfnt",
  "wiibrlan",
  "wiibrlyt",
  "wiibrsar",
  "wiibrstm",
  "wiiccf",
  "wiirseq",
  "wiitpl",
  "wiiwbz",
  "wim",
  "win994aticart",
  "winamplks",
  "winampm3u",
  "winampmaki",
  "winampq1",
  "winampsps",
  "winapesna",
  "winarchiverxdi",
  "winasksanl",
  "winasksask",
  "winasksrpt",
  "winaskswap",
  "wincatcat",
  "winccuap",
  "windevwde",
  "windevwdz",
  "windofcrypt",
  "windowmanagercmu",
  "windowscal",
  "windowscpx",
  "windowsdb",
  "windowseasymig",
  "windowseuf",
  "windowsfaxcpe",
  "windowsmediawtv",
  "windowssdi",
  "windowssearchfts",
  "windowsstorepackage",
  "windowswsstyles",
  "winereg",
  "winflashfls",
  "wingcommandermve",
  "wings3dwings",
  "wingzscz",
  "wingzwkz",
  "winhexpos",
  "winhexwhx",
  "winkript",
  "winkwnk",
  "winmountmou",
  "winoncdcpj",
  "winphone",
  "winphoneexap",
  "wintectk1",
  "wintectk2",
  "wintoetstst",
  "wintracwtf",
  "winuaecache",
  "winupack",
  "winviewspe",
  "wiresharkmplog",
  "wise",
  "wisews",
  "wizardwad",
  "wmf",
  "woff",
  "wolfwol",
  "wordperfect",
  "wordstar5",
  "wordstarpdf",
  "wordstarws2",
  "wordstarwsf",
  "wordupwfn",
  "workbenchewb",
  "workbenchewprj",
  "workbenchmsm",
  "worksheetbuilderwss",
  "worldmachinedev",
  "worldmachinepre",
  "worldmachinetmd",
  "worldstudio3dw",
  "wrapcandycwr",
  "writersblockwbk",
  "wrl",
  "ws",
  "wslcompresseddata",
  "wwarpwwp",
  "wwpack",
  "wysiwygwyg",
  "x3dvrml",
  "x3f",
  "xactxap",
  "xactxgs",
  "xactxsb",
  "xactxwb",
  "xar",
  "xarapgr",
  "xaraweb",
  "xarawix",
  "xaraxms",
  "xaraxws",
  "xbin",
  "xbox360xdbf",
  "xbox360xex",
  "xbox360xtaf",
  "xboxxbe",
  "xboxxbx",
  "xboxxtf",
  "xcadsft",
  "xcf",
  "xcr",
  "xcrypter",
  "xcrysdenxsf",
  "xcur",
  "xdcxdv",
  "xemicomputersadc",
  "xena",
  "xenodreamxep",
  "xfigvectorfig",
  "xiaobaencrypted",
  "xilinkxbcd",
  "xilinxbit",
  "xilinxngc",
  "xilinxnpl",
  "xilinxrbt",
  "xilinxwdb",
  "xm7t77",
  "xml",
  "xmp",
  "xneat",
  "xpack",
  "xpecxaf",
  "xpilotxp2",
  "xplaneafl",
  "xprofanpcu",
  "xpt",
  "xroarsnap",
  "xtrackerdmf",
  "xtreegolddrv",
  "xtremerat",
  "xul",
  "xwindowsxpm",
  "xwinplotxwp",
  "xxpack",
  "xyptcrypter",
  "xz",
  "xzpcontainerxzp",
  "yafaanimationyafa",
  "yaffs",
  "yamahapgm",
  "yamahar2a",
  "yamahar2p",
  "yamahar2s",
  "yamahar3a",
  "yamahas1m",
  "yamahas1v",
  "yamahatxw",
  "yamahavgf",
  "yamahavic",
  "yaz0arc",
  "yenc",
  "yetanotherbinder",
  "ygoproyrp",
  "ymstaudio",
  "yodacrypt",
  "yodaprotect",
  "youarefencrypted",
  "youidrawydr",
  "ysflightdnm",
  "ysflightfld",
  "ysflightsrf",
  "yugiohsav",
  "yukesyobj",
  "yuv4mpeg2y4m",
  "yzpack",
  "z",
  "zbrushgoz",
  "zbrushztl",
  "zbthumbnailinfo",
  "zeldaqst",
  "zeldaqsu",
  "zenglzei",
  "zenglzfi",
  "zenographicszjs",
  "zenworksaxt",
  "zeppelinencrypted",
  "zerogzeg",
  "zeroxzco",
  "zillionszsg",
  "zilogzws",
  "zincdataznc",
  "zinservdm",
  "zip",
  "zipgeniusczip",
  "zisrawczi",
  "zmodelerz3d",
  "zneszst",
  "zodbfs",
  "zonerbmi",
  "zonerzmf",
  "zoo",
  "zopezexp",
  "zortraxzcode",
  "zpaq",
  "ztrackerzt",
  "zxspectrummg",
  "zxspectrumnex",
  "zxspectrumtbu",
  "zxspectrumzxp",
  "zxstateszx",
  "zyxelzyx"
];
